import { render, staticRenderFns } from "./CollectionProgress.vue?vue&type=template&id=5adcc89a&scoped=true"
import script from "./CollectionProgress.vue?vue&type=script&lang=js"
export * from "./CollectionProgress.vue?vue&type=script&lang=js"
import style0 from "./CollectionProgress.vue?vue&type=style&index=0&id=5adcc89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adcc89a",
  null
  
)

export default component.exports